import { SxProps, Theme } from '@mui/material';

export const styles: Record<'root' | 'dialog', SxProps<Theme>> = {
  dialog: {
    backgroundColor: (theme) => theme.palette.background.paper,
    bottom: (theme) => theme.spacing(4),
    left: (theme) => ({
      sm: theme.spacing(4),
      xxs: 0,
    }),
    margin: 0,
    padding: (theme) => theme.spacing(4),
    position: 'fixed',
    width: {
      sm: 611,
      xxs: '100%',
    },
  },
  root: {
    bottom: 'unset',
    left: 'unset',
    right: 'unset',
    top: 'unset',
  },
};
